
<div class="list">
  <div class="d__flex header">
    <div>
      <h6 class="m-0 heading__">Pick form list</h6>
    </div>
    <ion-icon (click)="close_modal()" class="mouse" name="close-outline"></ion-icon>
  </div>

  <div class="box_sec">
    <div [class.active]="item['isActive']" (click)="add_warehous(item)" *ngFor="let item of product_values" class="d__flex mouse boxs">
      <h6 class="m-0 name_">{{item.options}}</h6>
      <ion-icon name="checkmark-circle-outline"></ion-icon>
    </div>
  </div>

  <div class="buttons_div">
    <!-- <ion-button class="close_btn" (click)="close_modal()" fill="clear">Close</ion-button> -->
    <ion-button class="close_btn" (click)="select_all(product_values)" fill="clear">Add All</ion-button>
    <ion-button (click)="save()" fill="clear">Proceed</ion-button>
  </div>

</div>